"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Endpoints = exports.ModelBases = void 0;
exports.ModelBases = {
  group: '/groups/',
  hacker: '/hackers/',
  sponsor: '/sponsors/',
  club: '/club/'
};
exports.Endpoints = {
  login: '/auth/login',
  categories: '/categories/',
  allCategories: '/categories/get_all_categories',
  specificCategory: function specificCategory(name, sponsor) {
    return "/api/categories?name=".concat(name, "&sponsor=").concat(sponsor);
  },
  clubGetEvents: '/club/get_events',
  clubRefreshEvents: '/club/refresh_events',
  emailVerify: function emailVerify(identifier) {
    return "/email/verify/".concat(identifier, "/");
  },
  createEvent: '/events/create_event',
  getAllEvents: '/events/get_all_events',
  updateEvent: function updateEvent(eventName) {
    return "/events/update_event/".concat(eventName, "/");
  },
  createGroup: exports.ModelBases.group,
  specificGroup: function specificGroup(groupName) {
    return exports.ModelBases.group + "".concat(groupName, "/");
  },
  groupMember: function groupMember(groupName, username) {
    return exports.ModelBases.group + "".concat(groupName, "/").concat(username, "/");
  },
  allGroups: exports.ModelBases.group + 'get_all_groups/',
  createHacker: exports.ModelBases.hacker,
  allHackers: exports.ModelBases.hacker + 'get_all_hackers/',
  specificHacker: function specificHacker(username) {
    return exports.ModelBases.hacker + "".concat(username, "/");
  },
  acceptHacker: function acceptHacker(username) {
    return exports.ModelBases.hacker + "".concat(username, "/accept/");
  },
  hackerSettings: function hackerSettings(username) {
    return exports.ModelBases.hacker + "".concat(username, "/settings/");
  },
  hackerResume: function hackerResume(username) {
    return exports.ModelBases.hacker + "".concat(username, "/resume/");
  },
  createSponsor: exports.ModelBases.sponsor,
  deleteSponsor: function deleteSponsor(sponsorName) {
    return exports.ModelBases.sponsor + "delete_sponsor/".concat(sponsorName);
  },
  allSponsors: exports.ModelBases.sponsor + 'get_all_sponsors/',
  specificSponsor: function specificSponsor(sponsorName) {
    return exports.ModelBases.sponsor + "".concat(sponsorName);
  },
  acceptSponsor: function acceptSponsor(username) {
    return exports.ModelBases.sponsor + "".concat(username, "/accept/");
  },
  clubEvents: "".concat(exports.ModelBases.club, "get_events/")
};